<div class="change-language-part">
	<div class="d-flex flex-column">
		<h4>Change Application Language</h4>
		<div class="d-flex flex-column gap-2">
			<common-select-field [field]="form.languageId()"></common-select-field>

			<common-button-row [center]="true">
				<button #languageSaveBtn class="btn btn-standard mt-2" [disabled]="form.disableSaveBtn()">
					Save Language
				</button>
			</common-button-row>
		</div>
	</div>
</div>